export default "__VITE_ASSET__BE55n4Nu__"